<script>

	import hitTest from "hit-test";

	export default {

        inject: [
            '$pageComponent',
            'editorComponent',
        ],

        props: {
            element: Object,
        },

        appearance: function() {
            return {
                icon: 'fa fa-fw fa-cube',
                name: null,
            };
        },

        created()
        {
        	/*
        	window.__debug = window.__debug || {};
        	window.__debug[this._uid] = this.element.get(0);

			console.info('###### Creating #' + this._uid + ', parent #' + this.$parent._uid + ', class: ' + this.element.attr('class'), ' childs: ', [...this.$children])
			console.info('###### Exists:', {...window.__debug});
            */

			this.initInstance();
			this.initAppearance();

            this.manageSelectable();
        },

        beforeDestroy()
		{
			this.element

				.removeAttr('data-vue-component')
				.removeData(['vue-component', 'vue-instance'])

				.unbind('click', this.setAsSelected);

			// delete window.__debug[this._uid];
            //console.info('###### Destroying #' + this._uid + ', class: ' + this.element.attr('class'), ' childs: ', [...this.$children])

            // Destroy childs.
            for(let child of [...this.$children]) {
				//console.info('Destroy child', { child, uid: child._uid })

				child.$destroy();
			}

			//console.info('###### Exists:', {...window.__debug});
		},

		methods: {

            initAppearance()
            {
                // Get original appearance.
                let originalAppearance = this.$options.appearance();

                // @ugly Why we need to overwrite the whole func?
                // Set name?
                if(!originalAppearance.name)
                    this.$options.appearance = () =>
                    {
                        return {
                            name: this.editableData.label || 'Naamloos item',
                            icon: originalAppearance.icon || 'fa fa-fw fa-cube',
                        };
                    };
            },

            initInstance()
            {
                // Set on element.
                this.element
                    .data('vueInstance', this)
                    .attr('data-vue-component', true);
            },

            manageSelectable()
            {
                // Reset selectable.
                this.element
                    .removeClass('canvas-selectable canvas-overview-root-block')
                    .unbind('click', this.setAsSelected);

                // Is root overview item?
                let isRootItemInOverview = this.pageComponent.activeMode == 'overview' && this.isRootBlock;

                if(isRootItemInOverview)
                    this.element
                        .addClass('canvas-overview-root-block')
                        .toggleClass('canvas-bg', !this.blockHasBg());

                // Editable due to content mode or is not a top component?
                if((this.pageComponent.activeMode == 'content' && this.isSelectable) || isRootItemInOverview)
                    this.element
                        .addClass('canvas-selectable')
                        .click(this.setAsSelected);
            },

            blockHasBg()
            {
                // Get visible bg color.
                let bgColor = window.getComputedStyle(this.element.get(0)).getPropertyValue('background-color');

                if(bgColor == 'rgba(0, 0, 0, 0)' || bgColor == 'transparent')
                    bgColor = false;

                // Get visible bg image.
                let bgImage = window.getComputedStyle(this.element.get(0)).getPropertyValue('background-image');

                if(bgImage == 'none' || bgImage == 'transparent')
                    bgImage = false;

                // Determine if has color or has image.
                return bgColor || bgImage ? true : false;
            },

            setAsSelected(event)
            {
                // Abort + avoid bubbling, since the user would like to put the cursor elsewhere in this contenteditable?
                if(this.element.is('[contenteditable=true]') && this.isSelected) {
                    return false;
				}

                // Abort due to marked as not selectable? Do allow bubbling.
                if($(event.target).is('[data-canvas-selectable=false]') || $(event.target).closest('[data-canvas-selectable=false]').length > 0) {
                	return;
				}

                // Set selection?
                if(this.pageComponent.selection.enabled)
                {
                    // Set as suggestion with alternatives?
                    if (this.pageComponent.activeMode == 'content')
                        this.pageComponent.selection.setUserSelection(this, {
                            x: event.pageX,
                            y: event.pageY,
                        });

                    // Set focus on this root block?
                    else if (this.pageComponent.activeMode == 'overview' && this.isRootBlock)
                        this.pageComponent.selection.setSelection(this);
                }

                // We might have been focussing on a contenteditable=true now, while we now show an alternative selection chooser. Undo this?
                if(this.pageComponent.selection.hasAlternativeEditors && this.element.is('[contenteditable=true]'))
                    this.element.blur();

                // Allow bubbling if selection is not enabled.
                return this.pageComponent.selection.enabled ? false : undefined;
            },

            // Overwrite when you editor needs to e.g. ask to save first.
			tryToDeselect()
            {
            	// It is fine to deselect.
            	return true;
            },

            getDomDepth()
            {
                return this.element.parents().length;
            },

			// TODO Review, to much data which nothing uses?
			getElementDimensions()
			{
				let offset = this.element.offset();
				let width = this.element.outerWidth();
				let height = this.element.outerHeight();

				// We scaled this.element to let the user see which element he is focussing on for the alternative selection chooser (see .canvas-hover).
				let boundingClientRect = this.element.get(0).getBoundingClientRect();
				let withoutScale = {
					height: (height - boundingClientRect.height) / 2,
					width: (width - boundingClientRect.width) / 2,
				};

				// Calculate bounding.
				return {
					top: offset.top - withoutScale.height,
					right: offset.left + width - withoutScale.width,
					bottom: offset.top + height,
					left: offset.left - withoutScale.width,
					width,
					height,
				};
			},


            // TODO Review
            mouseIsNearby(mouseCoords, clickedEditor)
            {
                // Determine rects.
                let elementOffset = this.element.offset();

                let elementRect = {
                    x: elementOffset.left,
                    y: elementOffset.top,
                    width: this.element.width(),
                    height: this.element.height(),
                };

                let elementInnerRect = {
                    x: elementRect.x + 30,
                    y: elementRect.y + 30,
                    width: elementRect.width - 2 * 30,
                    height: elementRect.height - 2 * 30,
                };

                let mouseRect = {
                    x: mouseCoords.x,
                    y: mouseCoords.y,
                    width: 1,
                    height: 1,
                };

                let clickedEditorRect = {
                    x: clickedEditor.element.offset().left,
                    y: clickedEditor.element.offset().top,
                    width: clickedEditor.element.width(),
                    height: clickedEditor.element.height(),
                };

                // Test for hit.
                return hitTest.Rectangle(elementRect, mouseRect); // && !hitTest.Rectangle(elementInnerRect, mouseRect);
            },


        },

        watch: {

            'pageComponent.selection.currentHover'(newVal)
            {
                // Show/hide as hovered. This is user for SelectionAlternatives.vue
                this.element.toggleClass('canvas-hover', newVal == this);
            },

            'pageComponent.selection.currentSelection'(newVal)
            {
                // Show/hide as selected.
                this.element.toggleClass('canvas-selected', newVal == this);
            },

            'pageComponent.activeMode'(newVal)
            {
            	this.manageSelectable();
            },

        },

        computed: {

            pageComponent()
            {
                // TODO
                return window.pageComponent; //this.$pageComponent();
            },

            canvasBlock()
            {
                // Ask parent EditableParent or AdminBlock.
                return this.$parent.canvasBlock;
            },

            isBlockEditor()
            {
                return !!this.editableData.blockId;
            },

            isRootBlock()
            {
                return this.$parent == this.pageComponent;
            },

            blockSelectionEnabled()
            {
                // Not enabled by selector?
                if(!this.pageComponent.selection.enabled)
                    return false;

                // Enabled due to every block is editablee?
                else if(this.pageComponent.activeMode == 'content')
                    return true;

                // Enabled due to is root block in overview mode?
                else if(this.pageComponent.activeMode == 'overview' && this.isRootBlock)
                    return true;

                // Not enabled?
                else
                    return false;
            },

            // TODO Rename to state? Or documentState?
            pageState()
            {
                return this.pageComponent.state;
            },

            editableData()
            {
                return this.element.data('canvas-editable');
            },

            panelComponent()
            {
                let componentTagPrefixComponentNamespace = '',
                    canvasBlockName = '';

                // Determine component prefix and canvas block name
                if (this.canvasBlock.block.includes('::')) {
                    componentTagPrefixComponentNamespace = this.canvasBlock.block.split('::')[0] + '--';
                    canvasBlockName = this.canvasBlock.block.split('::')[1].replace('.', '-').toLowerCase();
                } else {
                    canvasBlockName = this.canvasBlock.block.replace('.', '-').toLowerCase();
                }

                let panel = this.editableData.panel ? this.editableData.panel.toLowerCase() : 'panel';
                let tag = componentTagPrefixComponentNamespace + 'common-canvas-blocks-' + canvasBlockName + '-admin-' + panel;

                return window.Vue.options.components[tag] || null;
            },

            isSelected()
            {
                return this.pageComponent.selection.currentSelection == this;
            },

			isSelectable()
            {
            	return !!this.panelComponent;
            },

        },

    }

</script>

<style lang="scss">

    .galaxy\:\:common-canvas-editor-canvas-document-Page.selectable {

        // TODO Tricky CSS since they may already been used in the design of the block.
        .canvas-selectable {

            // TODO Tricky if used in block.scss
            cursor: pointer !important;
            outline: 0 solid transparent !important;
            transition: outline-color .15s linear, transform .2s !important;

            &:hover,
            &.canvas-hover {
                outline: 2px solid #0888c899 !important;
            }

            // TODO Rename to .alternative-selection-active?
            &.canvas-hover {
                outline: 2px solid #0888c899 !important;
                transform: scale(.9) !important;
            }

            &.canvas-selected {
                outline: 2px solid #0888c8 !important;
            }

            &.canvas-overview-root-block {
                @apply tw-shadow tw-rounded-lg;
                overflow: hidden;

                // Added if div does not have a bg color.
                &.canvas-bg {
                    background: white;
                }

                &:not(:last-child) {
                    margin-bottom: 60px !important;
                }

                & > * {
                    pointer-events: none;
                }
            }

        }

    }

</style>
